import React , { useState } from "react";
import {
    Container,
    Row
  } from "reactstrap";
import NavBarEspera from "./components/NavBarEspera";
import ContenedorSubVistasEspera from "./components/ContenedorSubVistasEspera";



function ListaDeEspera(){

    const [vista, setVista] = useState("EnEspera");
  
          return (
            <>
               
                <Container className="mt-3" fluid>
                    <Row>
                          {/* llamo a la nav con Botones varios */}
                          <NavBarEspera setVista={setVista}/>
                    </Row>
                    <Row>
                      <ContenedorSubVistasEspera vista={vista}/>
                    </Row>
                </Container>
                
            </>
           
        )

}


export default ListaDeEspera